export async function compressImage(file: File): Promise<string> {
  if (!file.type.startsWith('image/')) throw new Error('请选择图片文件')
  const bitmap = await createImageBitmap(file)
  const max = 900
  const scale = Math.min(1, max / Math.max(bitmap.width, bitmap.height))
  const canvas = document.createElement('canvas')
  canvas.width = Math.round(bitmap.width * scale)
  canvas.height = Math.round(bitmap.height * scale)
  const ctx = canvas.getContext('2d')
  if (!ctx) throw new Error('浏览器无法处理这张图片')
  ctx.drawImage(bitmap, 0, 0, canvas.width, canvas.height)
  let quality = 0.82
  let result = canvas.toDataURL('image/webp', quality)
  while (result.length > 540_000 && quality > 0.5) {
    quality -= 0.08
    result = canvas.toDataURL('image/webp', quality)
  }
  if (result.length > 560_000) throw new Error('图片压缩后仍超过约 400KB，请先裁剪后再上传')
  return result
}

export async function imageFromClipboard(event: ClipboardEvent): Promise<string | null> {
  const file = Array.from(event.clipboardData?.files || []).find((item) => item.type.startsWith('image/'))
  return file ? compressImage(file) : null
}
